import { StoreAction, XmAction } from 'store/actions';
import { BillingBannerInfo } from './models';

export function billingBannerReducer(state: BillingBannerInfo, action: XmAction<BillingBannerInfo>): BillingBannerInfo {
    switch (action.type) {
        case StoreAction.GET_BILLING_BANNER:
        case StoreAction.CLEAR_BILLING_BANNER:
            return action.payload;
        default:
            return state;
    }
}
